<i [ngClass]="name" class="icon"></i>
